import React, { useState, useRef, useEffect } from "react";
import RecordRTC from "recordrtc";
import logo from '../icici-bank.png';
import './VideoRecorder.css'; // Import the CSS file
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import { v4 as uuidv4 } from 'uuid'; // Import UUID for unique request_id
import { ReactComponent as MyIcon } from '../undraw_selected-box_qnrz.svg';
import arrow from '../curved-arrow.png'
import CryptoService from "./CyrptoService";

const VideoComponent = ({ setSuccess, setFlowDoc, documentImage, setFaceNotmatchStartAgain, refId }) => {
    // UI flow states
    const [uniqueId, setUniqueId] = useState(uuidv4());
    const [isLoading, setIsLoading] = useState(false); // true while accessing camera
    const [isCountingDown, setIsCountingDown] = useState(false);
    const [countdown, setCountdown] = useState(3);
    const [isRecording, setIsRecording] = useState(false);
    const [recordedVideoUrl, setRecordedVideoUrl] = useState("");
    const [faceSnapshotBase64, setFaceSnapshotBase64] = useState(""); // Store Base64 image
    const [illustrations, setIllustrations] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [faceDetected, setFaceDetected] = useState(false); // Track if face is detected

    const [loadingMessage, setLoadingMessage] = useState('')
    const [language, setLanguage] = useState("en"); // default language
    const [videoLoaded, setVideoLoaded] = useState(false);
    const [location, setLocation] = useState({ lat: null, long: null });

    // For demonstration, we limit recording to 10s and show a timer
    const [recordTime, setRecordTime] = useState(0);
    const maxRecordTime = 7; // adjust as needed

    // console.log('ketan111', documentImage);

    // New state for API response, submit button, and API loader
    const [apiTranscript, setApiTranscript] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [isSendingApi, setIsSendingApi] = useState(false);
    const [apiDisableScript, setApiDisableScript] = useState(false);
    // Fallback state – if native MediaRecorder is unsupported
    const [isFallback, setIsFallback] = useState(false);
    const [base64Video, setBase64Video] = useState('');
    const [randomNumber, setRandomNumber] = useState(0)
    const [startAgianHit, setStartagainHit] = useState(false)
    // Refs for video element and media objects
    const videoRef = useRef(null); // holds the video element
    const streamRef = useRef(null); // holds the camera stream
    const recorderRef = useRef(null); // holds either native recorder or RecordRTC instance

    // New state for video playback
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    // Declaration text in both languages
    // const declarationText = {
    //     en: "I do not want to add a nominee to my account.",//English
    //     hi: "मुझे अपने खाते में कोई नामांकित व्यक्ति नहीं जोड़ना है।",//Hindi
    //     gu: "હું મારા ખાતામાં કોઈ નામની ઉમેરો કરવા માંગતો/માગતી નથી.",//Gujarati
    //     mr: "मी माझ्या खात्यासाठी नामनिर्देशित व्यक्ती जोडू इच्छित नाही.",//Marathi
    //     ta: "நான் என் கணக்கிற்கு நியமிக்கப்பட்டவரை சேர்க்க விரும்பவில்லை.",//Tamil
    //     te: "నేను నా ఖాతాకు నామినీని జోడించలేను",//Telugu
    //     kn: "ನಾನು ನನ್ನ ಖಾತೆಗೆ ನಮೂದಿತ ವ್ಯಕ್ತಿಯನ್ನು ಸೇರಿಸಲು ಇಚ್ಛಿಸುವುದಿಲ್ಲ.",//Kannada
    //     ml: "ഞാൻ എന്റെ അക്കൗണ്ടിന് നാമനിർദേശിതനെ ചേർക്കാൻ ആഗ്രഹിക്കുന്നില്ല.",//Malayalam
    //     bn: "আমি আমার অ্যাকাউন্টে কোনও নমিনি যোগ করতে চাই না।",//Bengali
    //     // od: "ମୁଁ ସ୍ୱେଚ୍ଛାକୃତ ଭାବରେ ମୋ ଆକାଉଣ୍ଟରେ ଜଣେ ନୋମିନି ବାଛିବାକୁ ନିଷ୍ପତ୍ତି ନେଉଛି ନାହିଁ।",//Odia
    // };

    // Format seconds as "00:07"
    const formatTime = (sec) => (sec < 10 ? `0${sec}` : sec);
    // Check for native MediaRecorder support on mount
    useEffect(() => {
        if (
            typeof MediaRecorder === "undefined" ||
            !MediaRecorder.isTypeSupported("video/webm; codecs=vp8,opus")
        ) {
            console.warn("Native MediaRecorder not supported; using RecordRTC fallback.");
            setIsFallback(true);
        }
        captureGeo()

        setRandomNumber(Math.floor(Math.random() * (999 - 100 + 1)) + 100)
    }, []);

    const captureGeo = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                    });
                },
                (error) => {
                    console.error("Error fetching location:", error);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };

    // Helper function: send video blob to API (including language field)
    // const sendAudioToApi = (blob) => {
    //     setIsSendingApi(true);
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //         const base64data = reader.result.split(",")[1];
    //         const payload = {
    //             latitude: location.lat,
    //             longitude: location.long,
    //             device: /iPad|iPhone|iPod/i.test(navigator.userAgent) ? "ios" : "android",
    //             media: base64data,
    //             facebyte: faceSnapshotBase64 || "",
    //             language: language,
    //             request_id: uniqueId,
    //             client_id: '123_ketan'
    //         };

    //         fetch("https://kl0igqgz8f.execute-api.ap-south-1.amazonaws.com/default/nominee_verification", {
    //             method: "POST",
    //             headers: {
    //                 "x-api-key": "67DKlH24PiKwYdTxHzy7Ou4XBuEz7g5ZV9rkW500",
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(payload),
    //         })
    //             .then((res) => res.json())
    //             .then((data) => {
    //                 console.log("API response:", data);
    //                 setApiTranscript(data.transcript?.transcript || "No text found, please try again.");
    //                 setSubmitDisabled(data.result === false);
    //                 if (data.result === false) {
    //                     // setApiTranscript('Kindly say the exact statement so we can proceed smoothly with your request.')
    //                     setApiDisableScript(true)
    //                 }
    //                 setIsSendingApi(false);
    //             })
    //             .catch((error) => {
    //                 console.error("Error sending audio:", error);
    //                 setIsSendingApi(false);
    //             });
    //     };
    //     reader.readAsDataURL(blob);
    // };

    // Start or stop recording based on current state
    const handleCaptureClick = async () => {
        setIllustrations(false);
        if (!isRecording && !isCountingDown && !recordedVideoUrl) {
            setIsLoading(true);
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: true,
                    audio: true,
                });
                streamRef.current = stream;

                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.muted = true;
                    videoRef.current.play();

                    // Add this code to handle iOS devices
                    const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
                    if (isIOS) {
                        videoRef.current.setAttribute('playsinline', 'true');
                        videoRef.current.setAttribute('controls', 'true');
                    }
                }

                setIsLoading(false);
                setCountdown(3);
                setIsCountingDown(true);

                // Simulate face detection (assuming face is detected)
                setTimeout(() => setFaceDetected(true), 1000); // Simulated detection after 1 second

            } catch (error) {
                console.error("Error accessing camera:", error);
                setIsLoading(false);
                if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                    alert('Camera and microphone permissions are required to record the video.');
                }
            }
        } else if (isRecording) {
            stopRecording();
        }
    };

    // Countdown effect
    useEffect(() => {
        let timer;
        if (isCountingDown && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        } else if (isCountingDown && countdown === 0) {
            setIsCountingDown(false);
            // Capture and store the face snapshot
            const faceBase64 = captureFaceSnapshot();
            setFaceSnapshotBase64(faceBase64);
            // console.log("Stored Face Snapshot in State:", faceBase64 ? faceBase64.substring(0, 50) + "..." : "EMPTY");
            console.log("Stored Face Snapshot in State:", faceBase64);
            startRecording(faceBase64);
            overlayRandomNumber();
        }
        return () => clearTimeout(timer);
    }, [isCountingDown, countdown]);

    const captureFaceSnapshot = () => {
        if (videoRef.current) {
            const canvas = document.createElement("canvas");
            canvas.width = videoRef.current.videoWidth || 640;  // Ensure valid width
            canvas.height = videoRef.current.videoHeight || 480; // Ensure valid height
            const ctx = canvas.getContext("2d");
            ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
            const base64Image = canvas.toDataURL("image/jpeg").split(",")[1]; // Extract Base64
            return base64Image;
        }
        return "";
    };

    // Helper function to send video blob to API
    const sendVideoToApi = (blob, faceBase64) => {
        // console.log('blob :',blob );

        setIsSendingApi(true);
        setLoadingMessage('Please wait, we are analyzing your recorder video...')
        const reader = new FileReader();
        reader.onloadend = () => {
            const payload = {
                device: /iPad|iPhone|iPod/i.test(navigator.userAgent) ? "ios" : "android",
                bas64string: reader.result?.toString().split(',')[1],
            };
            // console.log('payload :', payload);

            setBase64Video(reader.result?.toString().split(',')[1]);

            fetch("https://wnawjozykj.execute-api.ap-south-1.amazonaws.com/default/speech_to_text_test", {
                method: "POST",
                headers: {
                    "x-api-key": "li0ZNckous14N6JCsq3pk4bVqtavmGHV7ZXOZcFm",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })
                .then((res) => res.json())
                .then((data) => {
                    // funFaceMatch(faceBase64)
                    if (data.data == "") {
                        // alert('please say again')
                        // setApiTranscript(data.transcript?.transcript || "Please try again.");
                        setIsSendingApi(false);
                    }
                    if (data.data == randomNumber.toString()) {
                        // alert('text speech match')
                        // setApiTranscript(data.transcript?.transcript || "Please try again.");
                        // funFaceDetcetion(faceBase64)
                        funFaceMatch(faceBase64)
                    } else {
                        setLoadingMessage('')
                        setApiTranscript(data.transcript?.transcript || "Invalid OTP, Please try again.");
                    }
                })
                .catch((error) => {
                    console.error("Error sending video:", `${error}`);
                    setIsSendingApi(false);
                });
        };
        reader.readAsDataURL(blob);
    };


    const startRecording = (faceBase64) => {
        setRecordTime(0);
        if (streamRef.current) {
            const audioStream = new MediaStream();
            const videoStream = new MediaStream();

            // Separate audio and video tracks
            streamRef.current.getTracks().forEach(track => {
                if (track.kind === 'audio') {
                    audioStream.addTrack(track);
                } else if (track.kind === 'video') {
                    videoStream.addTrack(track);
                }
            });

            if (isFallback) {
                // Use RecordRTC fallback – try using MediaStreamRecorder which tends to work on iOS
                recorderRef.current = RecordRTC(audioStream, {
                    type: "audio",
                    mimeType: "audio/wav",
                    recorderType: RecordRTC.MediaStreamRecorder,
                });
                recorderRef.current.startRecording();
                // recorderRef.current.overlayRandomNumber()
                setIsRecording(true);
            } else {
                // Use native MediaRecorder for audio
                let audioChunks = [];

                // Use native MediaRecorder for video
                let videoChunks = [];
                try {
                    const videoRecorder = new MediaRecorder(streamRef.current, {
                        mimeType: "video/webm; codecs=vp8,opus",
                    });

                    videoRecorder.ondataavailable = (event) => {
                        if (event.data && event.data.size > 0) {
                            videoChunks.push(event.data);
                        }
                    };

                    const audioRecorder = new MediaRecorder(audioStream, {
                        mimeType: "audio/webm; codecs=opus",  // Only audio format
                    });


                    audioRecorder.ondataavailable = (event) => {
                        if (event.data && event.data.size > 0) {
                            audioChunks.push(event.data);
                        }
                    };

                    audioRecorder.onstop = () => {

                        const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
                        const videoBlob = new Blob(videoChunks, { type: "video/webm" });

                        // Convert the Blob to Base64
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            const base64Video = reader.result.split(',')[1]; // Extract Base64 string
                            setRecordedVideoUrl(base64Video); // Save the Base64 string to state
                            // console.log("Base64 Video:", base64Video); // Optional: Log the Base64 string
                        };
                        reader.readAsDataURL(videoBlob);
                        sendVideoToApi(audioBlob, faceBase64); // Send the video/audio to the API
                    };
                    audioRecorder.start();
                    recorderRef.current = audioRecorder;
                    setIsRecording(true);
                } catch (e) {
                    console.error("Video MediaRecorder initialization failed:", e);
                    setIsFallback(true);
                    startRecording();
                    overlayRandomNumber();
                    return;
                }
            }
        }
    };


    const overlayRandomNumber = () => {
        if (videoRef.current && streamRef.current) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // Wait for the video to load metadata
            videoRef.current.addEventListener("loadedmetadata", () => {
                // Set canvas dimensions to match the video feed
                canvas.width = videoRef.current.videoWidth || 640;
                canvas.height = videoRef.current.videoHeight || 480;

                // Create a stream from the canvas
                const canvasStream = canvas.captureStream();

                // Combine audio from the original stream with the canvas stream
                const audioTracks = streamRef.current.getAudioTracks();
                audioTracks.forEach((track) => canvasStream.addTrack(track));

                // Draw the video and randomNumber on the canvas at regular intervals
                const drawInterval = setInterval(() => {
                    if (videoRef.current.readyState >= 2) { // Ensure the video is ready
                        ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
                        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height); // Draw the video feed
                        // Overlay the randomNumber
                        ctx.font = "30px Arial";
                        ctx.fillStyle = "white";
                        ctx.fillText(randomNumber, canvas.width / 2 - 50, 50); // Adjust position as needed
                    }
                }, 100);

                // Use MediaRecorder to record the canvas stream
                let videoChunks = [];
                try {
                    const videoRecorder = new MediaRecorder(canvasStream, {
                        mimeType: "video/webm; codecs=vp8,opus",
                    });

                    videoRecorder.ondataavailable = (event) => {
                        if (event.data && event.data.size > 0) {
                            videoChunks.push(event.data);
                        }
                    };

                    videoRecorder.onstop = () => {
                        clearInterval(drawInterval); // Stop drawing on the canvas
                        const videoBlob = new Blob(videoChunks, { type: "video/webm" });

                        // Convert the Blob to Base64
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            const base64Video = reader.result.split(",")[1]; // Extract Base64 string
                            setRecordedVideoUrl(base64Video); // Save the Base64 string to state
                            console.log("Base64 Video:", base64Video); // Optional: Log the Base64 string
                        };
                        reader.readAsDataURL(videoBlob);

                        sendVideoToApi(videoBlob); // Send the video to the API
                    };

                    videoRecorder.start();
                    recorderRef.current = videoRecorder;
                } catch (e) {
                    console.error("Video MediaRecorder initialization failed:", e);
                }
            });
        }
    };



    const stopRecording = () => {
        // if (isFallback && recorderRef.current) {
        //     recorderRef.current.stopRecording(() => {
        //         const blob = recorderRef.current.getBlob();
        //         const url = URL.createObjectURL(blob);
        //         setRecordedVideoUrl(url);
        //         if (videoRef.current) {
        //             videoRef.current.pause();
        //             videoRef.current.srcObject = null;
        //             videoRef.current.src = url;
        //             videoRef.current.muted = false;
        //             videoRef.current.load();
        //             videoRef.current.play();
        //         }
        //         sendVideoToApi(blob);
        //     });
        // } else if (recorderRef.current) {
        //     recorderRef.current.stop();
        // }
        // if (streamRef.current) {
        //     streamRef.current.getTracks().forEach((track) => track.stop());
        // }
        // setIsRecording(false);
        if (isFallback && recorderRef.current) {
            recorderRef.current.stopRecording(() => {
                const blob = recorderRef.current.getBlob();
                sendVideoToApi(blob);
            });
        } else if (recorderRef.current) {
            recorderRef.current.stop();
            recorderRef.current = null; // Reset the recorder reference
        }

        if (streamRef.current) {
            streamRef.current.getTracks().forEach((track) => track.stop());
        }

        setIsRecording(false);
    };

    // Update record time each second
    useEffect(() => {
        let interval;
        if (isRecording && recordTime < maxRecordTime) {
            interval = setInterval(() => {
                setRecordTime((prev) => prev + 1);
            }, 1000);
        }

        if (recordTime === maxRecordTime) {
            stopRecording();
        }
        return () => clearInterval(interval);
    }, [isRecording, recordTime]);

    // Retake: clear recorded video and automatically start capture stream
    const handleRetake = async () => {
        setRecordedVideoUrl("");
        setBase64Video("")
        setRecordTime(0);
        setApiTranscript("");
        setRandomNumber(Math.floor(Math.random() * (999 - 100 + 1)) + 100)


        // Stop any existing stream
        if (streamRef.current) {
            streamRef.current.getTracks().forEach((track) => track.stop());
        }

        // Reset the video element
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.srcObject = null; // Clear the video source
            videoRef.current.removeAttribute("src"); // Remove any cached source
            videoRef.current.load(); // Reset the video element
        }

        // Restart the video stream
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
            });
            streamRef.current = stream;

            if (videoRef.current) {
                // videoRef.current.setAttribute('playsinline', 'true'); // iOS-specific
                // videoRef.current.setAttribute('muted', 'true'); // Ensure autoplay works
                // videoRef.current.muted = true;
                // await videoRef.current.play();
                videoRef.current.srcObject = stream;
                videoRef.current.muted = true;
                videoRef.current.setAttribute("playsinline", "true"); // iOS-specific
                await videoRef.current.play();
            }
            // Start countdown and recording again
            setCountdown(3);
            setIsCountingDown(true);
        } catch (error) {
            console.error("Error restarting camera:", error);
            if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                alert('Camera and microphone permissions are required to record the video.');
            }
        }

        handleCaptureClick();
    };

    // // Submit placeholder
    // const handleSubmitVideo = async () => {
    //     setVideoLoaded(true);
    //     setIsSendingApi(true);
    //     setSubmitLoading(true);

    //     // Generate unique request_id
    //     const requestId = `file_${uniqueId}`; //uuidv4();
    //     console.log("Generated Request ID:", requestId);

    //     try {
    //         // Step 1: Fetch the pre-signed URL
    //         const presignedUrlResponse = await fetch(
    //             `https://kl0igqgz8f.execute-api.ap-south-1.amazonaws.com/default/presignedurl?request_id=${requestId}&client_id=123_ketan`,
    //             {
    //                 method: "POST",
    //                 headers: {
    //                     "x-api-key": "67DKlH24PiKwYdTxHzy7Ou4XBuEz7g5ZV9rkW500",
    //                 },
    //             }
    //         );

    //         const presignedUrlData = await presignedUrlResponse.json();
    //         console.log("Presigned URL Response:", presignedUrlData);

    //         if (!presignedUrlData.upload_url) {
    //             console.error("Failed to get upload URL");
    //             setIsSendingApi(false);
    //             return;
    //         }

    //         const uploadUrl = presignedUrlData.upload_url;

    //         // Step 2: Convert the video file to Blob
    //         const videoBlob = await fetch(recordedVideoUrl).then(res => res.blob());

    //         // setSuccess(true);
    //         // Step 3: Upload video to presigned URL using PUT request
    //         const uploadResponse = await fetch(uploadUrl, {
    //             method: "PUT",
    //             body: videoBlob,  // Sending video as binary data
    //             headers: {
    //                 "Content-Type": "video/webm",  // Set correct content type
    //             },
    //         });

    //         if (uploadResponse.ok) {
    //             console.log("Video successfully uploaded!");
    //             setSuccess(true);
    //             setSubmitLoading(false);
    //         } else {
    //             console.error("Error uploading video:", uploadResponse);
    //         }
    //     } catch (error) {
    //         console.error("Error in handleSubmitVideo:", error);
    //     }
    //     setIsSendingApi(false);
    // };

    // // Play/Pause video
    // const handlePlayPause = () => {
    //     if (isPlaying) {
    //         videoRef.current.pause();
    //     } else {
    //         videoRef.current.play();
    //     }
    //     setIsPlaying(!isPlaying);
    // };

    // Update current time and duration

    const handleTimeUpdate = () => {
        setCurrentTime(videoRef.current.currentTime);
        setDuration(videoRef.current.duration);
    };

    // Handle slider change
    // const handleSliderChange = (e) => {
    //     const newTime = e.target.value;
    //     videoRef.current.currentTime = newTime;
    //     setCurrentTime(newTime);
    // };

    async function funFaceMatch(faceBase64) {

        setLoadingMessage('Matching face with the document')
        const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
        let payload1
        if (isIOS) {
            payload1 = {
                DocImage: `${documentImage}`,
                SelfieImage: `${faceSnapshotBase64}`,
            };
        } else {
            payload1 = {
                DocImage: `${documentImage}`,
                SelfieImage: `${faceBase64}`,
            };
        }

        console.log("Stored Face Snapshot in State:", documentImage ? documentImage + "..." : "EMPTY");
        console.log("Stored Face Snapshot in State:", faceBase64 ? faceBase64 + "..." : "EMPTY");
        await fetch("https://7izf2fny08.execute-api.ap-south-1.amazonaws.com/default/facematchservice", {
            method: "POST",
            headers: {
                "x-api-key": "jCSIISHVNG2e3QLKbX0P82l6LyFM4oLj3mAyUH5R",
                "authorizationToken": "7Qeb3IoX5pxc214L",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload1),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.confidence_score > 80) {
                    function lmbd_ovd_step_status() {
                        let obj = { request_id: refId, is_document_uploaded: true, is_ipv_done: true, is_face_match_done: true }
                        // console.log('lmbd_ovd_step_status:', obj);

                        // Encrypt
                        const encrypted = CryptoService.encrypt(obj);
                        console.log("encrypted", encrypted);

                        const myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/json");

                        const raw = JSON.stringify({
                            "data": encrypted,
                            "source_id": "1"
                        });

                        const requestOptions = {
                            method: "POST",
                            headers: myHeaders,
                            body: raw,
                            redirect: "follow"
                        };

                        fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/step_status", requestOptions)
                            .then((response) => response.json())
                            .then((result) => {
                                // console.log(result);
                                // Decrypt
                                const decrypted = CryptoService.decrypt(result.data);
                                console.log('lmbd_ovd_step_status:', JSON.parse(decrypted));

                            })
                            .catch((error) => console.error(error));

                    }
                    lmbd_ovd_step_status()
                    setSuccess(true)
                } else {
                    setLoadingMessage('Face Not match with document Start Again')
                    setStartagainHit(true)
                }
            })
            .catch((error) => {
                console.log("ketan :", error);
                alert("Error sending video:", error);
                setLoadingMessage('Face Not match with document Start Again')
                setStartagainHit(true)
            })
    }

    const handleStartAgian = () => {
        // console.log("Start Again clicked");
        videoRef.current = null; // Reset video element
        streamRef.current = null; // Reset stream reference
        recorderRef.current = null; // Reset recorder reference
        setFlowDoc('DocumentUpload')
    }

    return (
        <div className="video-recorder-container">
            {/* Main container */}
            <div className="video-recorder-main" style={{ background: 'linear-gradient(0deg, rgba(255,219,169,1) 3%, rgba(255,236,209,1) 50%, rgba(255,240,219,1) 70%)', }}>
                <div className="video-recorder-top-bar"  >
                    <img src={logo} className="App-logo" alt="logo" style={{ padding: 3, width: '150px' }} />
                </div>

                <div style={{ width: "100%", position: "relative", marginTop: '4px' }}>
                    <div
                        style={{
                            height: "1.5px",
                            width: "100%",
                            background: "#ccc",
                            borderRadius: "2px",
                            position: "relative",
                        }}
                    >
                        <div
                            style={{
                                height: "1.5px",
                                width: "50%",
                                background: "#007bff",
                                borderRadius: "2px",
                                position: "absolute",
                            }}
                        ></div>
                        <div
                            style={{
                                height: "8px",
                                width: "8px",
                                background: "#007bff",
                                borderRadius: "50%",
                                position: "absolute",
                                left: "50%",
                                top: "50%",
                                transform: "translate(-50%, -50%)",
                            }}
                        ></div>
                    </div>
                </div>

                {/* Heading & Declaration */}
                <h2 className="video-recorder-heading">OVD</h2>
                <div>
                    <p className="video-recorder-declaration">Read out the OTP written on your screen by recording a video</p>
                    <p className="video-recorder-declaration-text">00:{formatTime(recordTime)} / 00:{formatTime(maxRecordTime)}</p>
                </div>


                {/* Video container */}
                <div className="video-recorder-video-container" style={{ maxHeight: "400px" }}>
                    {/* Blinking countdown in the center of the video */}
                    {isCountingDown && (
                        <div>
                            <div className="video-recorder-countdown" >
                                {countdown}
                            </div>
                        </div>
                    )}


                    {/*------Video Component------ */}
                    <div style={{ position: 'relative', width: "100%", height: "100%" }}>
                        {/* Video Component */}
                        <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            onTimeUpdate={handleTimeUpdate}
                            style={{
                                width: '100%',
                                height: '100%',
                                clipPath: 'circle(150px at center)', // Adjust the radius as needed
                                display: isRecording ? 'block' : 'none',
                                transform: 'scaleX(-1)', // Flip the video horizontally
                                border: '1px solid red',
                                marginRight: "1rem"
                            }}
                        />

                        {/* Centered Text */}
                        {
                            isRecording &&
                            <div
                                style={{
                                    position: "absolute",
                                    top: "20%", // Adjust the distance from the top
                                    left: "50%",
                                    transform: "translate(-50%, -50%)", // Center horizontally and vertically
                                    backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background for better visibility
                                    color: "white",
                                    padding: "5px 10px",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    zIndex: 10, // Ensure it appears above the video
                                }}
                            >
                                {randomNumber}
                            </div>
                        }
                    </div>

                    {/* Illustrations */}
                    {
                        illustrations &&
                        <>
                            <div style={{ width: '90%', margin: 'auto', position: 'absolute', top: 0, background: "white", padding: 20, borderRadius: '10px' }}>
                                <div style={{ height: '10%', marginLeft: '20px' }}>
                                    <h3 style={{ fontFamily: 'sans-serif' }}>DOs and DON'Ts</h3>
                                </div>
                                <div>
                                    <ul>
                                        <li style={{ padding: 5 }}>📽️ Record a video</li>
                                        <li style={{ padding: 5 }}>🎶 No background noise</li>
                                        <li style={{ padding: 5 }}>🙂 Face must be clearly visible</li>
                                        <li style={{ padding: 5 }}>💁 Voice must be clear and not muffled</li>
                                        <li style={{ padding: 5 }}>😎 Remove any accessories</li>
                                    </ul>
                                </div>
                            </div>
                        </>
                    }

                    {
                        loadingMessage &&
                        <>
                            <div
                                style={{
                                    position: 'absolute',
                                    // border: '1px solid red',
                                    // left: '40%',
                                    bottom: '40%',
                                    width: '98%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    zIndex: 999
                                }}
                            >
                                <span
                                    style={{
                                        backgroundColor: 'rgba(222, 217, 217, 0.45)',
                                        padding: 8,
                                        borderRadius: '10px',
                                        textAlign: 'center',
                                    }}
                                >
                                    <p className="text-shine">{loadingMessage}</p>
                                </span>
                            </div>
                        </>
                    }


                    {/* Capture/Stop button overlay at bottom center (only when no recorded video exists) */}
                    {!recordedVideoUrl && (
                        <>
                            <div style={{
                                position: 'absolute', bottom: 0, left: '50%',
                                transform: 'translateX(-50%)',
                            }}>
                                {
                                    illustrations &&
                                    <button
                                        onClick={handleCaptureClick}
                                        className="video-recorder-capture-button"
                                        style={{
                                            width: "10rem",
                                            height: '40px',
                                            border: '1px solid rgb(188, 39, 39)',
                                            backgroundColor: "rgb(186, 0, 0)",
                                            // borderRadius: "10%",
                                            // backgroundColor: isRecording ? "rgb(170, 168, 168)" : "rgba(252, 74, 74, 0.92)",
                                            cursor: "pointer",
                                            padding: 2,
                                            color: 'white'
                                        }}
                                    >
                                        {/* {isRecording ? "Stop Recording" : "Start Recording"} */}
                                        Start Recording
                                    </button>
                                }
                            </div>
                        </>
                    )}

                    {recordedVideoUrl && (
                        <div>
                            {/* Remove or comment out the video playback UI */}
                            {/* <video src={recordedVideoUrl} controls /> */}
                        </div>
                    )}

                    {
                        startAgianHit &&
                        <div style={{
                            position: 'absolute', bottom: 0, left: '50%',
                            transform: 'translateX(-50%)',
                        }}>

                            <button
                                onClick={handleStartAgian}
                                className="video-recorder-capture-button"
                                style={{
                                    width: "15rem",
                                    height: '40px',
                                    border: '1px solid rgb(188, 39, 39)',
                                    backgroundColor: "rgb(174, 1, 1)",
                                    borderRadius: "5px",
                                    // borderRadius: "10%",
                                    // backgroundColor: isRecording ? "rgb(170, 168, 168)" : "rgba(252, 74, 74, 0.92)",
                                    cursor: "pointer",
                                    padding: 2,
                                    color: 'white'
                                }}
                            >
                                {/* {isRecording ? "Stop Recording" : "Start Recording"} */}
                                Start Again
                            </button>

                        </div>
                    }

                    {/* Transcript display */}
                    {apiTranscript && (
                        <div style={{ position: 'absolute', left: '50%', bottom: '25%', transform: 'translate(-50%, 50%)', }}>
                            {/* {
                                apiDisableScript ? <> <div className="video-recorder-transcript">
                                    <p style={{ color: 'red' }} >Kindly say the exact statement so we can proceed smoothly with your request.</p>
                                </div></> :
                                    <div className="video-recorder-transcript" >
                                        <p>{apiTranscript}</p>
                                    </div>
                            } */}
                            <div className="video-recorder-transcript" >
                                <p>{apiTranscript} </p>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",

                                }}
                            >
                                <button
                                    onClick={handleRetake}
                                    style={{
                                        width: '7rem',
                                        height: '40px',
                                        border: "1.5px solid #a3cef1",
                                        backgroundColor: "#e7e4ff",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                    }}
                                >
                                    Retake
                                </button>
                                {/* {

                                videoLoaded ?
                                    <button className="animated-button">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <p className="btn-shine"> Processing...</p>
                                    </button>
                                    :
                                    <button
                                        onClick={handleSubmitVideo}
                                        disabled={submitDisabled}
                                        style={{
                                            width: '65%',
                                            height: '40px',
                                            border: "1.5px solid #a3cef1",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            backgroundColor: '',
                                            color: 'black'
                                        }}
                                    >
                                        Submit Video
                                    </button>
                            } */}
                            </div>
                        </div>
                    )}

                </div>
            </div>

            {/* Keyframes for blink animation */}
            <style>
                {`
                    @keyframes blink {
                        0% { opacity: 1; }
                        50% { opacity: 0.2; }
                        100% { opacity: 1; }
                    }
                `}
            </style>
        </div>
    );
};

export default VideoComponent;